// source: TollingVisionService.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

import jspb, { Message, BinaryReader, BinaryWriter } from "google-protobuf";
var goog = jspb;
var global =
  (typeof globalThis !== "undefined" && globalThis) ||
  (typeof window !== "undefined" && window) ||
  (typeof global !== "undefined" && global) ||
  (typeof self !== "undefined" && self) ||
  function () {
    return this;
  }.call(null) ||
  Function("return this")();

goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Color",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Dimensions",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Error",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.ErrorResponse",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.EventRequest",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.EventResponse",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.EventResponse.ResponseCase",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.EventResult",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Image",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.KeyValuePair",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.LicenseService",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Mmr",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.PartialResult",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.PartialResult.ResponseCase",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Plate",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.PlateChar",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Point",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Quadrilateral",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Region",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.ResultType",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.SearchRequest",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.SearchResponse",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Sign",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.SignType",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Status",
  null,
  global
);
goog.exportSymbol(
  "proto.com.smartcloudsolutions.tollingvision.Vehicle",
  null,
  global
);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Point = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.Point, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Point.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Point";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Region = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.smartcloudsolutions.tollingvision.Region.repeatedFields_,
    null
  );
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.Region, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Region.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Region";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral = function (
  opt_data
) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.Quadrilateral,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Quadrilateral.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Quadrilateral";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Color = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.Color, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Color.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Color";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.PlateChar, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.PlateChar.displayName =
    "proto.com.smartcloudsolutions.tollingvision.PlateChar";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.Dimensions, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Dimensions.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Dimensions";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Image = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.Image, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Image.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Image";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Plate = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.smartcloudsolutions.tollingvision.Plate.repeatedFields_,
    null
  );
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.Plate, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Plate.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Plate";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Mmr = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.Mmr, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Mmr.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Mmr";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Sign = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.smartcloudsolutions.tollingvision.Sign.repeatedFields_,
    null
  );
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.Sign, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Sign.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Sign";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.smartcloudsolutions.tollingvision.Vehicle.repeatedFields_,
    null
  );
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.Vehicle, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.Vehicle.displayName =
    "proto.com.smartcloudsolutions.tollingvision.Vehicle";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.KeyValuePair = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.KeyValuePair,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.KeyValuePair.displayName =
    "proto.com.smartcloudsolutions.tollingvision.KeyValuePair";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.LicenseService = function (
  opt_data
) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.LicenseService,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseService.displayName =
    "proto.com.smartcloudsolutions.tollingvision.LicenseService";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus = function (
  opt_data
) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.displayName =
    "proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest = function (
  opt_data
) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.smartcloudsolutions.tollingvision.SearchRequest.repeatedFields_,
    null
  );
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.SearchRequest,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.SearchRequest.displayName =
    "proto.com.smartcloudsolutions.tollingvision.SearchRequest";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.smartcloudsolutions.tollingvision.EventRequest.repeatedFields_,
    null
  );
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.EventRequest,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.EventRequest.displayName =
    "proto.com.smartcloudsolutions.tollingvision.EventRequest";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest = function (
  opt_data
) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.displayName =
    "proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest =
  function (opt_data) {
    Message.initialize(this, opt_data, 0, -1, null, null);
  };
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.displayName =
    "proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse = function (
  opt_data
) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.ErrorResponse,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.ErrorResponse.displayName =
    "proto.com.smartcloudsolutions.tollingvision.ErrorResponse";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse = function (
  opt_data
) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.smartcloudsolutions.tollingvision.SearchResponse.repeatedFields_,
    null
  );
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.SearchResponse,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.SearchResponse.displayName =
    "proto.com.smartcloudsolutions.tollingvision.SearchResponse";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.EventResult = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.smartcloudsolutions.tollingvision.EventResult.repeatedFields_,
    null
  );
};
goog.inherits(proto.com.smartcloudsolutions.tollingvision.EventResult, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.EventResult.displayName =
    "proto.com.smartcloudsolutions.tollingvision.EventResult";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult = function (
  opt_data
) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    null,
    proto.com.smartcloudsolutions.tollingvision.PartialResult.oneofGroups_
  );
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.PartialResult,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.PartialResult.displayName =
    "proto.com.smartcloudsolutions.tollingvision.PartialResult";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse = function (
  opt_data
) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    null,
    proto.com.smartcloudsolutions.tollingvision.EventResponse.oneofGroups_
  );
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.EventResponse,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.EventResponse.displayName =
    "proto.com.smartcloudsolutions.tollingvision.EventResponse";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse = function (
  opt_data
) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse
      .repeatedFields_,
    null
  );
};
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.displayName =
    "proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse =
  function (opt_data) {
    Message.initialize(
      this,
      opt_data,
      0,
      -1,
      proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse
        .repeatedFields_,
      null
    );
  };
goog.inherits(
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse,
  Message
);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.displayName =
    "proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse";
}

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Point.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Point.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Point} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Point.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        x: Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
        y: Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Point}
 */
proto.com.smartcloudsolutions.tollingvision.Point.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.com.smartcloudsolutions.tollingvision.Point();
  return proto.com.smartcloudsolutions.tollingvision.Point.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Point} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Point}
 */
proto.com.smartcloudsolutions.tollingvision.Point.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readDouble());
          msg.setX(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readDouble());
          msg.setY(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Point.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Point.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Point} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Point.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getX();
    if (f !== 0.0) {
      writer.writeDouble(1, f);
    }
    f = message.getY();
    if (f !== 0.0) {
      writer.writeDouble(2, f);
    }
  };

/**
 * optional double x = 1;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Point.prototype.getX = function () {
  return /** @type {number} */ (
    Message.getFloatingPointFieldWithDefault(this, 1, 0.0)
  );
};

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Point} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Point.prototype.setX = function (
  value
) {
  return Message.setProto3FloatField(this, 1, value);
};

/**
 * optional double y = 2;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Point.prototype.getY = function () {
  return /** @type {number} */ (
    Message.getFloatingPointFieldWithDefault(this, 2, 0.0)
  );
};

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Point} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Point.prototype.setY = function (
  value
) {
  return Message.setProto3FloatField(this, 2, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.Region.repeatedFields_ = [1];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Region.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Region.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Region} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Region.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        pointList: Message.toObjectList(
          msg.getPointList(),
          proto.com.smartcloudsolutions.tollingvision.Point.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Region}
 */
proto.com.smartcloudsolutions.tollingvision.Region.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.Region();
    return proto.com.smartcloudsolutions.tollingvision.Region.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Region} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Region}
 */
proto.com.smartcloudsolutions.tollingvision.Region.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.com.smartcloudsolutions.tollingvision.Point();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Point
              .deserializeBinaryFromReader
          );
          msg.addPoint(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Region.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Region.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Region} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Region.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getPointList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        1,
        f,
        proto.com.smartcloudsolutions.tollingvision.Point
          .serializeBinaryToWriter
      );
    }
  };

/**
 * repeated Point point = 1;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Point>}
 */
proto.com.smartcloudsolutions.tollingvision.Region.prototype.getPointList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Point>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Point,
        1
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Point>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Region} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Region.prototype.setPointList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 1, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Point=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Point}
 */
proto.com.smartcloudsolutions.tollingvision.Region.prototype.addPoint =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      1,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Point,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Region} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Region.prototype.clearPointList =
  function () {
    return this.setPointList([]);
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Quadrilateral.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Quadrilateral.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          topLeft:
            (f = msg.getTopLeft()) &&
            proto.com.smartcloudsolutions.tollingvision.Point.toObject(
              includeInstance,
              f
            ),
          topRight:
            (f = msg.getTopRight()) &&
            proto.com.smartcloudsolutions.tollingvision.Point.toObject(
              includeInstance,
              f
            ),
          bottomLeft:
            (f = msg.getBottomLeft()) &&
            proto.com.smartcloudsolutions.tollingvision.Point.toObject(
              includeInstance,
              f
            ),
          bottomRight:
            (f = msg.getBottomRight()) &&
            proto.com.smartcloudsolutions.tollingvision.Point.toObject(
              includeInstance,
              f
            ),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.Quadrilateral();
    return proto.com.smartcloudsolutions.tollingvision.Quadrilateral.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.com.smartcloudsolutions.tollingvision.Point();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Point
              .deserializeBinaryFromReader
          );
          msg.setTopLeft(value);
          break;
        case 2:
          var value = new proto.com.smartcloudsolutions.tollingvision.Point();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Point
              .deserializeBinaryFromReader
          );
          msg.setTopRight(value);
          break;
        case 3:
          var value = new proto.com.smartcloudsolutions.tollingvision.Point();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Point
              .deserializeBinaryFromReader
          );
          msg.setBottomLeft(value);
          break;
        case 4:
          var value = new proto.com.smartcloudsolutions.tollingvision.Point();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Point
              .deserializeBinaryFromReader
          );
          msg.setBottomRight(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Quadrilateral.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getTopLeft();
    if (f != null) {
      writer.writeMessage(
        1,
        f,
        proto.com.smartcloudsolutions.tollingvision.Point
          .serializeBinaryToWriter
      );
    }
    f = message.getTopRight();
    if (f != null) {
      writer.writeMessage(
        2,
        f,
        proto.com.smartcloudsolutions.tollingvision.Point
          .serializeBinaryToWriter
      );
    }
    f = message.getBottomLeft();
    if (f != null) {
      writer.writeMessage(
        3,
        f,
        proto.com.smartcloudsolutions.tollingvision.Point
          .serializeBinaryToWriter
      );
    }
    f = message.getBottomRight();
    if (f != null) {
      writer.writeMessage(
        4,
        f,
        proto.com.smartcloudsolutions.tollingvision.Point
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional Point top_left = 1;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Point}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.getTopLeft =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Point} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Point,
        1
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Point|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.setTopLeft =
  function (value) {
    return Message.setWrapperField(this, 1, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.clearTopLeft =
  function () {
    return this.setTopLeft(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.hasTopLeft =
  function () {
    return Message.getField(this, 1) != null;
  };

/**
 * optional Point top_right = 2;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Point}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.getTopRight =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Point} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Point,
        2
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Point|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.setTopRight =
  function (value) {
    return Message.setWrapperField(this, 2, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.clearTopRight =
  function () {
    return this.setTopRight(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.hasTopRight =
  function () {
    return Message.getField(this, 2) != null;
  };

/**
 * optional Point bottom_left = 3;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Point}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.getBottomLeft =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Point} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Point,
        3
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Point|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.setBottomLeft =
  function (value) {
    return Message.setWrapperField(this, 3, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.clearBottomLeft =
  function () {
    return this.setBottomLeft(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.hasBottomLeft =
  function () {
    return Message.getField(this, 3) != null;
  };

/**
 * optional Point bottom_right = 4;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Point}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.getBottomRight =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Point} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Point,
        4
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Point|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.setBottomRight =
  function (value) {
    return Message.setWrapperField(this, 4, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Quadrilateral} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.clearBottomRight =
  function () {
    return this.setBottomRight(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Quadrilateral.prototype.hasBottomRight =
  function () {
    return Message.getField(this, 4) != null;
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Color.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Color.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Color} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Color.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        red: Message.getFieldWithDefault(msg, 1, 0),
        green: Message.getFieldWithDefault(msg, 2, 0),
        blue: Message.getFieldWithDefault(msg, 3, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Color}
 */
proto.com.smartcloudsolutions.tollingvision.Color.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.com.smartcloudsolutions.tollingvision.Color();
  return proto.com.smartcloudsolutions.tollingvision.Color.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Color} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Color}
 */
proto.com.smartcloudsolutions.tollingvision.Color.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setRed(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setGreen(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setBlue(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Color.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Color.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Color} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Color.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getRed();
    if (f !== 0) {
      writer.writeUint32(1, f);
    }
    f = message.getGreen();
    if (f !== 0) {
      writer.writeUint32(2, f);
    }
    f = message.getBlue();
    if (f !== 0) {
      writer.writeUint32(3, f);
    }
  };

/**
 * optional uint32 red = 1;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Color.prototype.getRed =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 1, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Color} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Color.prototype.setRed = function (
  value
) {
  return Message.setProto3IntField(this, 1, value);
};

/**
 * optional uint32 green = 2;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Color.prototype.getGreen =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 2, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Color} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Color.prototype.setGreen =
  function (value) {
    return Message.setProto3IntField(this, 2, value);
  };

/**
 * optional uint32 blue = 3;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Color.prototype.getBlue =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 3, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Color} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Color.prototype.setBlue = function (
  value
) {
  return Message.setProto3IntField(this, 3, value);
};

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.PlateChar.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.PlateChar} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.PlateChar.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        code: Message.getFieldWithDefault(msg, 1, 0),
        confidence: Message.getFieldWithDefault(msg, 2, 0),
        position:
          (f = msg.getPosition()) &&
          proto.com.smartcloudsolutions.tollingvision.Quadrilateral.toObject(
            includeInstance,
            f
          ),
        color:
          (f = msg.getColor()) &&
          proto.com.smartcloudsolutions.tollingvision.Color.toObject(
            includeInstance,
            f
          ),
        backgroundColor:
          (f = msg.getBackgroundColor()) &&
          proto.com.smartcloudsolutions.tollingvision.Color.toObject(
            includeInstance,
            f
          ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.PlateChar();
    return proto.com.smartcloudsolutions.tollingvision.PlateChar.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.PlateChar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setCode(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setConfidence(value);
          break;
        case 3:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.Quadrilateral();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Quadrilateral
              .deserializeBinaryFromReader
          );
          msg.setPosition(value);
          break;
        case 4:
          var value = new proto.com.smartcloudsolutions.tollingvision.Color();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Color
              .deserializeBinaryFromReader
          );
          msg.setColor(value);
          break;
        case 5:
          var value = new proto.com.smartcloudsolutions.tollingvision.Color();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Color
              .deserializeBinaryFromReader
          );
          msg.setBackgroundColor(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.PlateChar.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.PlateChar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getCode();
    if (f !== 0) {
      writer.writeUint32(1, f);
    }
    f = message.getConfidence();
    if (f !== 0) {
      writer.writeUint32(2, f);
    }
    f = message.getPosition();
    if (f != null) {
      writer.writeMessage(
        3,
        f,
        proto.com.smartcloudsolutions.tollingvision.Quadrilateral
          .serializeBinaryToWriter
      );
    }
    f = message.getColor();
    if (f != null) {
      writer.writeMessage(
        4,
        f,
        proto.com.smartcloudsolutions.tollingvision.Color
          .serializeBinaryToWriter
      );
    }
    f = message.getBackgroundColor();
    if (f != null) {
      writer.writeMessage(
        5,
        f,
        proto.com.smartcloudsolutions.tollingvision.Color
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional uint32 code = 1;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.getCode =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 1, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.setCode =
  function (value) {
    return Message.setProto3IntField(this, 1, value);
  };

/**
 * optional uint32 confidence = 2;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.getConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 2, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.setConfidence =
  function (value) {
    return Message.setProto3IntField(this, 2, value);
  };

/**
 * optional Quadrilateral position = 3;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Quadrilateral}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.getPosition =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Quadrilateral} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Quadrilateral,
        3
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Quadrilateral|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.setPosition =
  function (value) {
    return Message.setWrapperField(this, 3, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.clearPosition =
  function () {
    return this.setPosition(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.hasPosition =
  function () {
    return Message.getField(this, 3) != null;
  };

/**
 * optional Color color = 4;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Color}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.getColor =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Color} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Color,
        4
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Color|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.setColor =
  function (value) {
    return Message.setWrapperField(this, 4, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.clearColor =
  function () {
    return this.setColor(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.hasColor =
  function () {
    return Message.getField(this, 4) != null;
  };

/**
 * optional Color background_color = 5;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Color}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.getBackgroundColor =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Color} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Color,
        5
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Color|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.setBackgroundColor =
  function (value) {
    return Message.setWrapperField(this, 5, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.clearBackgroundColor =
  function () {
    return this.setBackgroundColor(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.PlateChar.prototype.hasBackgroundColor =
  function () {
    return Message.getField(this, 5) != null;
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Dimensions.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Dimensions.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Dimensions} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Dimensions.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        width: Message.getFieldWithDefault(msg, 1, 0),
        height: Message.getFieldWithDefault(msg, 2, 0),
        length: Message.getFieldWithDefault(msg, 3, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Dimensions}
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.Dimensions();
    return proto.com.smartcloudsolutions.tollingvision.Dimensions.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Dimensions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Dimensions}
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setWidth(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setHeight(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setLength(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Dimensions.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Dimensions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getWidth();
    if (f !== 0) {
      writer.writeUint32(1, f);
    }
    f = message.getHeight();
    if (f !== 0) {
      writer.writeUint32(2, f);
    }
    f = message.getLength();
    if (f !== 0) {
      writer.writeUint32(3, f);
    }
  };

/**
 * optional uint32 width = 1;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.prototype.getWidth =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 1, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Dimensions} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.prototype.setWidth =
  function (value) {
    return Message.setProto3IntField(this, 1, value);
  };

/**
 * optional uint32 height = 2;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.prototype.getHeight =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 2, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Dimensions} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.prototype.setHeight =
  function (value) {
    return Message.setProto3IntField(this, 2, value);
  };

/**
 * optional uint32 length = 3;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.prototype.getLength =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 3, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Dimensions} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Dimensions.prototype.setLength =
  function (value) {
    return Message.setProto3IntField(this, 3, value);
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Image.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Image.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Image} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Image.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        data: msg.getData_asB64(),
        name: Message.getFieldWithDefault(msg, 2, ""),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Image}
 */
proto.com.smartcloudsolutions.tollingvision.Image.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.com.smartcloudsolutions.tollingvision.Image();
  return proto.com.smartcloudsolutions.tollingvision.Image.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Image} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Image}
 */
proto.com.smartcloudsolutions.tollingvision.Image.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setData(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Image.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Image.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Image} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Image.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getData_asU8();
    if (f.length > 0) {
      writer.writeBytes(1, f);
    }
    f = message.getName();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };

/**
 * optional bytes data = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Image.prototype.getData =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Image.prototype.getData_asB64 =
  function () {
    return /** @type {string} */ (Message.bytesAsB64(this.getData()));
  };

/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Image.prototype.getData_asU8 =
  function () {
    return /** @type {!Uint8Array} */ (Message.bytesAsU8(this.getData()));
  };

/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Image} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Image.prototype.setData = function (
  value
) {
  return Message.setProto3BytesField(this, 1, value);
};

/**
 * optional string name = 2;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Image.prototype.getName =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 2, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Image} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Image.prototype.setName = function (
  value
) {
  return Message.setProto3StringField(this, 2, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.Plate.repeatedFields_ = [13];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Plate.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Plate.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Plate} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Plate.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        text: Message.getFieldWithDefault(msg, 1, ""),
        country: Message.getFieldWithDefault(msg, 2, ""),
        state: Message.getFieldWithDefault(msg, 3, ""),
        category: Message.getFieldWithDefault(msg, 4, ""),
        confidence: Message.getFieldWithDefault(msg, 5, 0),
        position:
          (f = msg.getPosition()) &&
          proto.com.smartcloudsolutions.tollingvision.Quadrilateral.toObject(
            includeInstance,
            f
          ),
        width: Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
        height: Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
        processingTime: Message.getFieldWithDefault(msg, 9, 0),
        separatedText: Message.getFieldWithDefault(msg, 10, ""),
        plateTypeConfidence: Message.getFieldWithDefault(msg, 11, 0),
        textConfidence: Message.getFieldWithDefault(msg, 12, 0),
        characterList: Message.toObjectList(
          msg.getCharacterList(),
          proto.com.smartcloudsolutions.tollingvision.PlateChar.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.com.smartcloudsolutions.tollingvision.Plate();
  return proto.com.smartcloudsolutions.tollingvision.Plate.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Plate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setText(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setCountry(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setState(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setCategory(value);
          break;
        case 5:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setConfidence(value);
          break;
        case 6:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.Quadrilateral();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Quadrilateral
              .deserializeBinaryFromReader
          );
          msg.setPosition(value);
          break;
        case 7:
          var value = /** @type {number} */ (reader.readFloat());
          msg.setWidth(value);
          break;
        case 8:
          var value = /** @type {number} */ (reader.readFloat());
          msg.setHeight(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setProcessingTime(value);
          break;
        case 10:
          var value = /** @type {string} */ (reader.readString());
          msg.setSeparatedText(value);
          break;
        case 11:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setPlateTypeConfidence(value);
          break;
        case 12:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setTextConfidence(value);
          break;
        case 13:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.PlateChar();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.PlateChar
              .deserializeBinaryFromReader
          );
          msg.addCharacter(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Plate.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Plate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Plate.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getText();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getCountry();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message.getState();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
    f = message.getCategory();
    if (f.length > 0) {
      writer.writeString(4, f);
    }
    f = message.getConfidence();
    if (f !== 0) {
      writer.writeUint32(5, f);
    }
    f = message.getPosition();
    if (f != null) {
      writer.writeMessage(
        6,
        f,
        proto.com.smartcloudsolutions.tollingvision.Quadrilateral
          .serializeBinaryToWriter
      );
    }
    f = message.getWidth();
    if (f !== 0.0) {
      writer.writeFloat(7, f);
    }
    f = message.getHeight();
    if (f !== 0.0) {
      writer.writeFloat(8, f);
    }
    f = message.getProcessingTime();
    if (f !== 0) {
      writer.writeUint64(9, f);
    }
    f = message.getSeparatedText();
    if (f.length > 0) {
      writer.writeString(10, f);
    }
    f = message.getPlateTypeConfidence();
    if (f !== 0) {
      writer.writeUint32(11, f);
    }
    f = message.getTextConfidence();
    if (f !== 0) {
      writer.writeUint32(12, f);
    }
    f = message.getCharacterList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        13,
        f,
        proto.com.smartcloudsolutions.tollingvision.PlateChar
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional string text = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getText =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setText = function (
  value
) {
  return Message.setProto3StringField(this, 1, value);
};

/**
 * optional string country = 2;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getCountry =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 2, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setCountry =
  function (value) {
    return Message.setProto3StringField(this, 2, value);
  };

/**
 * optional string state = 3;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getState =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 3, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setState =
  function (value) {
    return Message.setProto3StringField(this, 3, value);
  };

/**
 * optional string category = 4;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getCategory =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 4, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setCategory =
  function (value) {
    return Message.setProto3StringField(this, 4, value);
  };

/**
 * optional uint32 confidence = 5;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 5, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setConfidence =
  function (value) {
    return Message.setProto3IntField(this, 5, value);
  };

/**
 * optional Quadrilateral position = 6;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Quadrilateral}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getPosition =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Quadrilateral} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Quadrilateral,
        6
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Quadrilateral|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setPosition =
  function (value) {
    return Message.setWrapperField(this, 6, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.clearPosition =
  function () {
    return this.setPosition(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.hasPosition =
  function () {
    return Message.getField(this, 6) != null;
  };

/**
 * optional float width = 7;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getWidth =
  function () {
    return /** @type {number} */ (
      Message.getFloatingPointFieldWithDefault(this, 7, 0.0)
    );
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setWidth =
  function (value) {
    return Message.setProto3FloatField(this, 7, value);
  };

/**
 * optional float height = 8;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getHeight =
  function () {
    return /** @type {number} */ (
      Message.getFloatingPointFieldWithDefault(this, 8, 0.0)
    );
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setHeight =
  function (value) {
    return Message.setProto3FloatField(this, 8, value);
  };

/**
 * optional uint64 processing_time = 9;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getProcessingTime =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 9, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setProcessingTime =
  function (value) {
    return Message.setProto3IntField(this, 9, value);
  };

/**
 * optional string separated_text = 10;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getSeparatedText =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 10, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setSeparatedText =
  function (value) {
    return Message.setProto3StringField(this, 10, value);
  };

/**
 * optional uint32 plate_type_confidence = 11;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getPlateTypeConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 11, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setPlateTypeConfidence =
  function (value) {
    return Message.setProto3IntField(this, 11, value);
  };

/**
 * optional uint32 text_confidence = 12;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getTextConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 12, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setTextConfidence =
  function (value) {
    return Message.setProto3IntField(this, 12, value);
  };

/**
 * repeated PlateChar character = 13;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.PlateChar>}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.getCharacterList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.PlateChar>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.PlateChar,
        13
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.PlateChar>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.setCharacterList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 13, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.PlateChar=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar}
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.addCharacter =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      13,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.PlateChar,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Plate.prototype.clearCharacterList =
  function () {
    return this.setCharacterList([]);
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Mmr.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Mmr} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Mmr.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        make: Message.getFieldWithDefault(msg, 1, ""),
        model: Message.getFieldWithDefault(msg, 2, ""),
        generation: Message.getFieldWithDefault(msg, 3, ""),
        color:
          (f = msg.getColor()) &&
          proto.com.smartcloudsolutions.tollingvision.Color.toObject(
            includeInstance,
            f
          ),
        colorName: Message.getFieldWithDefault(msg, 5, ""),
        standardColorName: Message.getFieldWithDefault(msg, 6, ""),
        category: Message.getFieldWithDefault(msg, 7, ""),
        bodyType: Message.getFieldWithDefault(msg, 8, ""),
        viewPoint: Message.getFieldWithDefault(msg, 9, ""),
        makeConfidence: Message.getFieldWithDefault(msg, 10, 0),
        modelConfidence: Message.getFieldWithDefault(msg, 11, 0),
        generationConfidence: Message.getFieldWithDefault(msg, 12, 0),
        colorConfidence: Message.getFieldWithDefault(msg, 13, 0),
        categoryConfidence: Message.getFieldWithDefault(msg, 14, 0),
        bodyTypeConfidence: Message.getFieldWithDefault(msg, 15, 0),
        viewPointConfidence: Message.getFieldWithDefault(msg, 16, 0),
        processingTime: Message.getFieldWithDefault(msg, 17, 0),
        dimensions:
          (f = msg.getDimensions()) &&
          proto.com.smartcloudsolutions.tollingvision.Dimensions.toObject(
            includeInstance,
            f
          ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.com.smartcloudsolutions.tollingvision.Mmr();
  return proto.com.smartcloudsolutions.tollingvision.Mmr.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Mmr} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setMake(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setModel(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setGeneration(value);
          break;
        case 4:
          var value = new proto.com.smartcloudsolutions.tollingvision.Color();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Color
              .deserializeBinaryFromReader
          );
          msg.setColor(value);
          break;
        case 5:
          var value = /** @type {string} */ (reader.readString());
          msg.setColorName(value);
          break;
        case 6:
          var value = /** @type {string} */ (reader.readString());
          msg.setStandardColorName(value);
          break;
        case 7:
          var value = /** @type {string} */ (reader.readString());
          msg.setCategory(value);
          break;
        case 8:
          var value = /** @type {string} */ (reader.readString());
          msg.setBodyType(value);
          break;
        case 9:
          var value = /** @type {string} */ (reader.readString());
          msg.setViewPoint(value);
          break;
        case 10:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setMakeConfidence(value);
          break;
        case 11:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setModelConfidence(value);
          break;
        case 12:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setGenerationConfidence(value);
          break;
        case 13:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setColorConfidence(value);
          break;
        case 14:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setCategoryConfidence(value);
          break;
        case 15:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setBodyTypeConfidence(value);
          break;
        case 16:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setViewPointConfidence(value);
          break;
        case 17:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setProcessingTime(value);
          break;
        case 18:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.Dimensions();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Dimensions
              .deserializeBinaryFromReader
          );
          msg.setDimensions(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Mmr.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Mmr} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getMake();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getModel();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message.getGeneration();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
    f = message.getColor();
    if (f != null) {
      writer.writeMessage(
        4,
        f,
        proto.com.smartcloudsolutions.tollingvision.Color
          .serializeBinaryToWriter
      );
    }
    f = message.getColorName();
    if (f.length > 0) {
      writer.writeString(5, f);
    }
    f = message.getStandardColorName();
    if (f.length > 0) {
      writer.writeString(6, f);
    }
    f = message.getCategory();
    if (f.length > 0) {
      writer.writeString(7, f);
    }
    f = message.getBodyType();
    if (f.length > 0) {
      writer.writeString(8, f);
    }
    f = message.getViewPoint();
    if (f.length > 0) {
      writer.writeString(9, f);
    }
    f = message.getMakeConfidence();
    if (f !== 0) {
      writer.writeUint32(10, f);
    }
    f = message.getModelConfidence();
    if (f !== 0) {
      writer.writeUint32(11, f);
    }
    f = message.getGenerationConfidence();
    if (f !== 0) {
      writer.writeUint32(12, f);
    }
    f = message.getColorConfidence();
    if (f !== 0) {
      writer.writeUint32(13, f);
    }
    f = message.getCategoryConfidence();
    if (f !== 0) {
      writer.writeUint32(14, f);
    }
    f = message.getBodyTypeConfidence();
    if (f !== 0) {
      writer.writeUint32(15, f);
    }
    f = message.getViewPointConfidence();
    if (f !== 0) {
      writer.writeUint32(16, f);
    }
    f = message.getProcessingTime();
    if (f !== 0) {
      writer.writeUint64(17, f);
    }
    f = message.getDimensions();
    if (f != null) {
      writer.writeMessage(
        18,
        f,
        proto.com.smartcloudsolutions.tollingvision.Dimensions
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional string make = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getMake =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setMake = function (
  value
) {
  return Message.setProto3StringField(this, 1, value);
};

/**
 * optional string model = 2;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getModel =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 2, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setModel = function (
  value
) {
  return Message.setProto3StringField(this, 2, value);
};

/**
 * optional string generation = 3;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getGeneration =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 3, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setGeneration =
  function (value) {
    return Message.setProto3StringField(this, 3, value);
  };

/**
 * optional Color color = 4;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Color}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getColor =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Color} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Color,
        4
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Color|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setColor = function (
  value
) {
  return Message.setWrapperField(this, 4, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.clearColor =
  function () {
    return this.setColor(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.hasColor =
  function () {
    return Message.getField(this, 4) != null;
  };

/**
 * optional string color_name = 5;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getColorName =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 5, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setColorName =
  function (value) {
    return Message.setProto3StringField(this, 5, value);
  };

/**
 * optional string standard_color_name = 6;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getStandardColorName =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 6, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setStandardColorName =
  function (value) {
    return Message.setProto3StringField(this, 6, value);
  };

/**
 * optional string category = 7;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getCategory =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 7, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setCategory =
  function (value) {
    return Message.setProto3StringField(this, 7, value);
  };

/**
 * optional string body_type = 8;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getBodyType =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 8, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setBodyType =
  function (value) {
    return Message.setProto3StringField(this, 8, value);
  };

/**
 * optional string view_point = 9;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getViewPoint =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 9, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setViewPoint =
  function (value) {
    return Message.setProto3StringField(this, 9, value);
  };

/**
 * optional uint32 make_confidence = 10;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getMakeConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 10, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setMakeConfidence =
  function (value) {
    return Message.setProto3IntField(this, 10, value);
  };

/**
 * optional uint32 model_confidence = 11;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getModelConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 11, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setModelConfidence =
  function (value) {
    return Message.setProto3IntField(this, 11, value);
  };

/**
 * optional uint32 generation_confidence = 12;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getGenerationConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 12, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setGenerationConfidence =
  function (value) {
    return Message.setProto3IntField(this, 12, value);
  };

/**
 * optional uint32 color_confidence = 13;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getColorConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 13, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setColorConfidence =
  function (value) {
    return Message.setProto3IntField(this, 13, value);
  };

/**
 * optional uint32 category_confidence = 14;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getCategoryConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 14, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setCategoryConfidence =
  function (value) {
    return Message.setProto3IntField(this, 14, value);
  };

/**
 * optional uint32 body_type_confidence = 15;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getBodyTypeConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 15, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setBodyTypeConfidence =
  function (value) {
    return Message.setProto3IntField(this, 15, value);
  };

/**
 * optional uint32 view_point_confidence = 16;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getViewPointConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 16, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setViewPointConfidence =
  function (value) {
    return Message.setProto3IntField(this, 16, value);
  };

/**
 * optional uint64 processing_time = 17;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getProcessingTime =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 17, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setProcessingTime =
  function (value) {
    return Message.setProto3IntField(this, 17, value);
  };

/**
 * optional Dimensions dimensions = 18;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Dimensions}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.getDimensions =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Dimensions} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Dimensions,
        18
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Dimensions|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.setDimensions =
  function (value) {
    return Message.setWrapperField(this, 18, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.clearDimensions =
  function () {
    return this.setDimensions(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Mmr.prototype.hasDimensions =
  function () {
    return Message.getField(this, 18) != null;
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.Sign.repeatedFields_ = [8];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Sign.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Sign.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Sign} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Sign.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        text: Message.getFieldWithDefault(msg, 1, ""),
        type: Message.getFieldWithDefault(msg, 2, 0),
        confidence: Message.getFieldWithDefault(msg, 3, 0),
        position:
          (f = msg.getPosition()) &&
          proto.com.smartcloudsolutions.tollingvision.Quadrilateral.toObject(
            includeInstance,
            f
          ),
        width: Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
        height: Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
        processingTime: Message.getFieldWithDefault(msg, 7, 0),
        characterList: Message.toObjectList(
          msg.getCharacterList(),
          proto.com.smartcloudsolutions.tollingvision.PlateChar.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.com.smartcloudsolutions.tollingvision.Sign();
  return proto.com.smartcloudsolutions.tollingvision.Sign.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Sign} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setText(value);
          break;
        case 2:
          var value =
            /** @type {!proto.com.smartcloudsolutions.tollingvision.SignType} */ (
              reader.readEnum()
            );
          msg.setType(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setConfidence(value);
          break;
        case 4:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.Quadrilateral();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Quadrilateral
              .deserializeBinaryFromReader
          );
          msg.setPosition(value);
          break;
        case 5:
          var value = /** @type {number} */ (reader.readFloat());
          msg.setWidth(value);
          break;
        case 6:
          var value = /** @type {number} */ (reader.readFloat());
          msg.setHeight(value);
          break;
        case 7:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setProcessingTime(value);
          break;
        case 8:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.PlateChar();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.PlateChar
              .deserializeBinaryFromReader
          );
          msg.addCharacter(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Sign.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Sign} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Sign.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getText();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getType();
    if (f !== 0.0) {
      writer.writeEnum(2, f);
    }
    f = message.getConfidence();
    if (f !== 0) {
      writer.writeUint32(3, f);
    }
    f = message.getPosition();
    if (f != null) {
      writer.writeMessage(
        4,
        f,
        proto.com.smartcloudsolutions.tollingvision.Quadrilateral
          .serializeBinaryToWriter
      );
    }
    f = message.getWidth();
    if (f !== 0.0) {
      writer.writeFloat(5, f);
    }
    f = message.getHeight();
    if (f !== 0.0) {
      writer.writeFloat(6, f);
    }
    f = message.getProcessingTime();
    if (f !== 0) {
      writer.writeUint64(7, f);
    }
    f = message.getCharacterList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        8,
        f,
        proto.com.smartcloudsolutions.tollingvision.PlateChar
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional string text = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.getText =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.setText = function (
  value
) {
  return Message.setProto3StringField(this, 1, value);
};

/**
 * optional SignType type = 2;
 * @return {!proto.com.smartcloudsolutions.tollingvision.SignType}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.getType =
  function () {
    return /** @type {!proto.com.smartcloudsolutions.tollingvision.SignType} */ (
      Message.getFieldWithDefault(this, 2, 0)
    );
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.SignType} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.setType = function (
  value
) {
  return Message.setProto3EnumField(this, 2, value);
};

/**
 * optional uint32 confidence = 3;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.getConfidence =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 3, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.setConfidence =
  function (value) {
    return Message.setProto3IntField(this, 3, value);
  };

/**
 * optional Quadrilateral position = 4;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Quadrilateral}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.getPosition =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Quadrilateral} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Quadrilateral,
        4
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Quadrilateral|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.setPosition =
  function (value) {
    return Message.setWrapperField(this, 4, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.clearPosition =
  function () {
    return this.setPosition(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.hasPosition =
  function () {
    return Message.getField(this, 4) != null;
  };

/**
 * optional float width = 5;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.getWidth =
  function () {
    return /** @type {number} */ (
      Message.getFloatingPointFieldWithDefault(this, 5, 0.0)
    );
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.setWidth = function (
  value
) {
  return Message.setProto3FloatField(this, 5, value);
};

/**
 * optional float height = 6;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.getHeight =
  function () {
    return /** @type {number} */ (
      Message.getFloatingPointFieldWithDefault(this, 6, 0.0)
    );
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.setHeight =
  function (value) {
    return Message.setProto3FloatField(this, 6, value);
  };

/**
 * optional uint64 processing_time = 7;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.getProcessingTime =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 7, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.setProcessingTime =
  function (value) {
    return Message.setProto3IntField(this, 7, value);
  };

/**
 * repeated PlateChar character = 8;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.PlateChar>}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.getCharacterList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.PlateChar>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.PlateChar,
        8
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.PlateChar>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.setCharacterList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 8, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.PlateChar=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.PlateChar}
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.addCharacter =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      8,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.PlateChar,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Sign.prototype.clearCharacterList =
  function () {
    return this.setCharacterList([]);
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.repeatedFields_ = [2, 4];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.Vehicle.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.Vehicle} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.Vehicle.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        plate:
          (f = msg.getPlate()) &&
          proto.com.smartcloudsolutions.tollingvision.Plate.toObject(
            includeInstance,
            f
          ),
        alternativeList: Message.toObjectList(
          msg.getAlternativeList(),
          proto.com.smartcloudsolutions.tollingvision.Plate.toObject,
          includeInstance
        ),
        mmr:
          (f = msg.getMmr()) &&
          proto.com.smartcloudsolutions.tollingvision.Mmr.toObject(
            includeInstance,
            f
          ),
        signList: Message.toObjectList(
          msg.getSignList(),
          proto.com.smartcloudsolutions.tollingvision.Sign.toObject,
          includeInstance
        ),
        frame:
          (f = msg.getFrame()) &&
          proto.com.smartcloudsolutions.tollingvision.Quadrilateral.toObject(
            includeInstance,
            f
          ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.Vehicle();
    return proto.com.smartcloudsolutions.tollingvision.Vehicle.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Vehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.com.smartcloudsolutions.tollingvision.Plate();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Plate
              .deserializeBinaryFromReader
          );
          msg.setPlate(value);
          break;
        case 2:
          var value = new proto.com.smartcloudsolutions.tollingvision.Plate();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Plate
              .deserializeBinaryFromReader
          );
          msg.addAlternative(value);
          break;
        case 3:
          var value = new proto.com.smartcloudsolutions.tollingvision.Mmr();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Mmr
              .deserializeBinaryFromReader
          );
          msg.setMmr(value);
          break;
        case 4:
          var value = new proto.com.smartcloudsolutions.tollingvision.Sign();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Sign
              .deserializeBinaryFromReader
          );
          msg.addSign(value);
          break;
        case 5:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.Quadrilateral();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Quadrilateral
              .deserializeBinaryFromReader
          );
          msg.setFrame(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.Vehicle.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.Vehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getPlate();
    if (f != null) {
      writer.writeMessage(
        1,
        f,
        proto.com.smartcloudsolutions.tollingvision.Plate
          .serializeBinaryToWriter
      );
    }
    f = message.getAlternativeList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        2,
        f,
        proto.com.smartcloudsolutions.tollingvision.Plate
          .serializeBinaryToWriter
      );
    }
    f = message.getMmr();
    if (f != null) {
      writer.writeMessage(
        3,
        f,
        proto.com.smartcloudsolutions.tollingvision.Mmr.serializeBinaryToWriter
      );
    }
    f = message.getSignList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        4,
        f,
        proto.com.smartcloudsolutions.tollingvision.Sign.serializeBinaryToWriter
      );
    }
    f = message.getFrame();
    if (f != null) {
      writer.writeMessage(
        5,
        f,
        proto.com.smartcloudsolutions.tollingvision.Quadrilateral
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional Plate plate = 1;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Plate}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.getPlate =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Plate} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Plate,
        1
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Plate|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.setPlate =
  function (value) {
    return Message.setWrapperField(this, 1, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.clearPlate =
  function () {
    return this.setPlate(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.hasPlate =
  function () {
    return Message.getField(this, 1) != null;
  };

/**
 * repeated Plate alternative = 2;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Plate>}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.getAlternativeList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Plate>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Plate,
        2
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Plate>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.setAlternativeList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 2, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Plate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.addAlternative =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      2,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Plate,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.clearAlternativeList =
  function () {
    return this.setAlternativeList([]);
  };

/**
 * optional Mmr mmr = 3;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Mmr}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.getMmr =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Mmr} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Mmr,
        3
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Mmr|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.setMmr =
  function (value) {
    return Message.setWrapperField(this, 3, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.clearMmr =
  function () {
    return this.setMmr(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.hasMmr =
  function () {
    return Message.getField(this, 3) != null;
  };

/**
 * repeated Sign sign = 4;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Sign>}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.getSignList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Sign>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Sign,
        4
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Sign>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.setSignList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 4, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Sign=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.addSign =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      4,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Sign,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.clearSignList =
  function () {
    return this.setSignList([]);
  };

/**
 * optional Quadrilateral frame = 5;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Quadrilateral}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.getFrame =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Quadrilateral} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Quadrilateral,
        5
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Quadrilateral|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.setFrame =
  function (value) {
    return Message.setWrapperField(this, 5, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle} returns this
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.clearFrame =
  function () {
    return this.setFrame(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.Vehicle.prototype.hasFrame =
  function () {
    return Message.getField(this, 5) != null;
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.KeyValuePair.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.KeyValuePair.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.KeyValuePair} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.KeyValuePair.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        key: Message.getFieldWithDefault(msg, 1, ""),
        value: Message.getFieldWithDefault(msg, 2, ""),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.KeyValuePair}
 */
proto.com.smartcloudsolutions.tollingvision.KeyValuePair.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.KeyValuePair();
    return proto.com.smartcloudsolutions.tollingvision.KeyValuePair.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.KeyValuePair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.KeyValuePair}
 */
proto.com.smartcloudsolutions.tollingvision.KeyValuePair.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setKey(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setValue(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.KeyValuePair.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.KeyValuePair.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.KeyValuePair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.KeyValuePair.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getKey();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getValue();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };

/**
 * optional string key = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.KeyValuePair.prototype.getKey =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.KeyValuePair} returns this
 */
proto.com.smartcloudsolutions.tollingvision.KeyValuePair.prototype.setKey =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * optional string value = 2;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.KeyValuePair.prototype.getValue =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 2, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.KeyValuePair} returns this
 */
proto.com.smartcloudsolutions.tollingvision.KeyValuePair.prototype.setValue =
  function (value) {
    return Message.setProto3StringField(this, 2, value);
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseService.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.LicenseService.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseService} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseService.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          name: Message.getFieldWithDefault(msg, 1, ""),
          address: Message.getFieldWithDefault(msg, 2, ""),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseService}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseService.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.LicenseService();
    return proto.com.smartcloudsolutions.tollingvision.LicenseService.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseService} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseService}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseService.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setAddress(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseService.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.LicenseService.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseService} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.LicenseService.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getName();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getAddress();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };

/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseService.prototype.getName =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseService} returns this
 */
proto.com.smartcloudsolutions.tollingvision.LicenseService.prototype.setName =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * optional string address = 2;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseService.prototype.getAddress =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 2, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseService} returns this
 */
proto.com.smartcloudsolutions.tollingvision.LicenseService.prototype.setAddress =
  function (value) {
    return Message.setProto3StringField(this, 2, value);
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          service:
            (f = msg.getService()) &&
            proto.com.smartcloudsolutions.tollingvision.LicenseService.toObject(
              includeInstance,
              f
            ),
          lastError: Message.getFieldWithDefault(msg, 2, ""),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg =
      new proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus();
    return proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.LicenseService();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.LicenseService
              .deserializeBinaryFromReader
          );
          msg.setService(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setLastError(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getService();
    if (f != null) {
      writer.writeMessage(
        1,
        f,
        proto.com.smartcloudsolutions.tollingvision.LicenseService
          .serializeBinaryToWriter
      );
    }
    f = message.getLastError();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };

/**
 * optional LicenseService service = 1;
 * @return {?proto.com.smartcloudsolutions.tollingvision.LicenseService}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.prototype.getService =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.LicenseService} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.LicenseService,
        1
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.LicenseService|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus} returns this
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.prototype.setService =
  function (value) {
    return Message.setWrapperField(this, 1, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus} returns this
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.prototype.clearService =
  function () {
    return this.setService(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.prototype.hasService =
  function () {
    return Message.getField(this, 1) != null;
  };

/**
 * optional string last_error = 2;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.prototype.getLastError =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 2, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus} returns this
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus.prototype.setLastError =
  function (value) {
    return Message.setProto3StringField(this, 2, value);
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.repeatedFields_ = [
  12,
];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.SearchRequest.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.SearchRequest.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          plateRecognition:
            (f = Message.getBooleanField(msg, 1)) == null ? undefined : f,
          makeAndModelRecognition: Message.getBooleanFieldWithDefault(
            msg,
            2,
            false
          ),
          signRecognition: Message.getBooleanFieldWithDefault(msg, 3, false),
          internationalRecognition: Message.getBooleanFieldWithDefault(
            msg,
            4,
            false
          ),
          resampling:
            (f = Message.getBooleanField(msg, 5)) == null ? undefined : f,
          resultsWithoutPlateType: Message.getBooleanFieldWithDefault(
            msg,
            6,
            false
          ),
          location: Message.getFieldWithDefault(msg, 7, ""),
          image:
            (f = msg.getImage()) &&
            proto.com.smartcloudsolutions.tollingvision.Image.toObject(
              includeInstance,
              f
            ),
          maxSearch: Message.getFieldWithDefault(msg, 9, 0),
          maxRotation: Message.getFieldWithDefault(msg, 10, 0),
          maxCharacterSize: Message.getFieldWithDefault(msg, 11, 0),
          regionList: Message.toObjectList(
            msg.getRegionList(),
            proto.com.smartcloudsolutions.tollingvision.Region.toObject,
            includeInstance
          ),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.SearchRequest();
    return proto.com.smartcloudsolutions.tollingvision.SearchRequest.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPlateRecognition(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setMakeAndModelRecognition(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setSignRecognition(value);
          break;
        case 4:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setInternationalRecognition(value);
          break;
        case 5:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setResampling(value);
          break;
        case 6:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setResultsWithoutPlateType(value);
          break;
        case 7:
          var value = /** @type {string} */ (reader.readString());
          msg.setLocation(value);
          break;
        case 8:
          var value = new proto.com.smartcloudsolutions.tollingvision.Image();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Image
              .deserializeBinaryFromReader
          );
          msg.setImage(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setMaxSearch(value);
          break;
        case 10:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setMaxRotation(value);
          break;
        case 11:
          var value = /** @type {number} */ (reader.readSint32());
          msg.setMaxCharacterSize(value);
          break;
        case 12:
          var value = new proto.com.smartcloudsolutions.tollingvision.Region();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Region
              .deserializeBinaryFromReader
          );
          msg.addRegion(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.SearchRequest.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ (Message.getField(message, 1));
    if (f != null) {
      writer.writeBool(1, f);
    }
    f = message.getMakeAndModelRecognition();
    if (f) {
      writer.writeBool(2, f);
    }
    f = message.getSignRecognition();
    if (f) {
      writer.writeBool(3, f);
    }
    f = message.getInternationalRecognition();
    if (f) {
      writer.writeBool(4, f);
    }
    f = /** @type {boolean} */ (Message.getField(message, 5));
    if (f != null) {
      writer.writeBool(5, f);
    }
    f = message.getResultsWithoutPlateType();
    if (f) {
      writer.writeBool(6, f);
    }
    f = message.getLocation();
    if (f.length > 0) {
      writer.writeString(7, f);
    }
    f = message.getImage();
    if (f != null) {
      writer.writeMessage(
        8,
        f,
        proto.com.smartcloudsolutions.tollingvision.Image
          .serializeBinaryToWriter
      );
    }
    f = message.getMaxSearch();
    if (f !== 0) {
      writer.writeUint32(9, f);
    }
    f = message.getMaxRotation();
    if (f !== 0) {
      writer.writeUint32(10, f);
    }
    f = message.getMaxCharacterSize();
    if (f !== 0) {
      writer.writeSint32(11, f);
    }
    f = message.getRegionList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        12,
        f,
        proto.com.smartcloudsolutions.tollingvision.Region
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional bool plate_recognition = 1;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getPlateRecognition =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 1, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setPlateRecognition =
  function (value) {
    return Message.setField(this, 1, value);
  };

/**
 * Clears the field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.clearPlateRecognition =
  function () {
    return Message.setField(this, 1, undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.hasPlateRecognition =
  function () {
    return Message.getField(this, 1) != null;
  };

/**
 * optional bool make_and_model_recognition = 2;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getMakeAndModelRecognition =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 2, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setMakeAndModelRecognition =
  function (value) {
    return Message.setProto3BooleanField(this, 2, value);
  };

/**
 * optional bool sign_recognition = 3;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getSignRecognition =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 3, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setSignRecognition =
  function (value) {
    return Message.setProto3BooleanField(this, 3, value);
  };

/**
 * optional bool international_recognition = 4;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getInternationalRecognition =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 4, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setInternationalRecognition =
  function (value) {
    return Message.setProto3BooleanField(this, 4, value);
  };

/**
 * optional bool resampling = 5;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getResampling =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 5, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setResampling =
  function (value) {
    return Message.setField(this, 5, value);
  };

/**
 * Clears the field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.clearResampling =
  function () {
    return Message.setField(this, 5, undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.hasResampling =
  function () {
    return Message.getField(this, 5) != null;
  };

/**
 * optional bool results_without_plate_type = 6;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getResultsWithoutPlateType =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 6, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setResultsWithoutPlateType =
  function (value) {
    return Message.setProto3BooleanField(this, 6, value);
  };

/**
 * optional string location = 7;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getLocation =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 7, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setLocation =
  function (value) {
    return Message.setProto3StringField(this, 7, value);
  };

/**
 * optional Image image = 8;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Image}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getImage =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Image} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Image,
        8
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Image|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setImage =
  function (value) {
    return Message.setWrapperField(this, 8, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.clearImage =
  function () {
    return this.setImage(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.hasImage =
  function () {
    return Message.getField(this, 8) != null;
  };

/**
 * optional uint32 max_search = 9;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getMaxSearch =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 9, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setMaxSearch =
  function (value) {
    return Message.setProto3IntField(this, 9, value);
  };

/**
 * optional uint32 max_rotation = 10;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getMaxRotation =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 10, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setMaxRotation =
  function (value) {
    return Message.setProto3IntField(this, 10, value);
  };

/**
 * optional sint32 max_character_size = 11;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getMaxCharacterSize =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 11, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setMaxCharacterSize =
  function (value) {
    return Message.setProto3IntField(this, 11, value);
  };

/**
 * repeated Region region = 12;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Region>}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.getRegionList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Region>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Region,
        12
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Region>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.setRegionList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 12, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Region=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Region}
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.addRegion =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      12,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Region,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchRequest.prototype.clearRegionList =
  function () {
    return this.setRegionList([]);
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.repeatedFields_ = [
  6, 7, 8, 12,
];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.EventRequest.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.EventRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.EventRequest.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        signRecognition: Message.getBooleanFieldWithDefault(msg, 1, false),
        internationalRecognition: Message.getBooleanFieldWithDefault(
          msg,
          2,
          false
        ),
        resampling:
          (f = Message.getBooleanField(msg, 3)) == null ? undefined : f,
        resultsWithoutPlateType: Message.getBooleanFieldWithDefault(
          msg,
          4,
          false
        ),
        location: Message.getFieldWithDefault(msg, 5, ""),
        frontImageList: Message.toObjectList(
          msg.getFrontImageList(),
          proto.com.smartcloudsolutions.tollingvision.Image.toObject,
          includeInstance
        ),
        rearImageList: Message.toObjectList(
          msg.getRearImageList(),
          proto.com.smartcloudsolutions.tollingvision.Image.toObject,
          includeInstance
        ),
        overviewImageList: Message.toObjectList(
          msg.getOverviewImageList(),
          proto.com.smartcloudsolutions.tollingvision.Image.toObject,
          includeInstance
        ),
        maxSearch: Message.getFieldWithDefault(msg, 9, 0),
        maxRotation: Message.getFieldWithDefault(msg, 10, 0),
        maxCharacterSize: Message.getFieldWithDefault(msg, 11, 0),
        regionList: Message.toObjectList(
          msg.getRegionList(),
          proto.com.smartcloudsolutions.tollingvision.Region.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.EventRequest();
    return proto.com.smartcloudsolutions.tollingvision.EventRequest.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.EventRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setSignRecognition(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setInternationalRecognition(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setResampling(value);
          break;
        case 4:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setResultsWithoutPlateType(value);
          break;
        case 5:
          var value = /** @type {string} */ (reader.readString());
          msg.setLocation(value);
          break;
        case 6:
          var value = new proto.com.smartcloudsolutions.tollingvision.Image();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Image
              .deserializeBinaryFromReader
          );
          msg.addFrontImage(value);
          break;
        case 7:
          var value = new proto.com.smartcloudsolutions.tollingvision.Image();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Image
              .deserializeBinaryFromReader
          );
          msg.addRearImage(value);
          break;
        case 8:
          var value = new proto.com.smartcloudsolutions.tollingvision.Image();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Image
              .deserializeBinaryFromReader
          );
          msg.addOverviewImage(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setMaxSearch(value);
          break;
        case 10:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setMaxRotation(value);
          break;
        case 11:
          var value = /** @type {number} */ (reader.readSint32());
          msg.setMaxCharacterSize(value);
          break;
        case 12:
          var value = new proto.com.smartcloudsolutions.tollingvision.Region();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Region
              .deserializeBinaryFromReader
          );
          msg.addRegion(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.EventRequest.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.EventRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getSignRecognition();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message.getInternationalRecognition();
    if (f) {
      writer.writeBool(2, f);
    }
    f = /** @type {boolean} */ (Message.getField(message, 3));
    if (f != null) {
      writer.writeBool(3, f);
    }
    f = message.getResultsWithoutPlateType();
    if (f) {
      writer.writeBool(4, f);
    }
    f = message.getLocation();
    if (f.length > 0) {
      writer.writeString(5, f);
    }
    f = message.getFrontImageList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        6,
        f,
        proto.com.smartcloudsolutions.tollingvision.Image
          .serializeBinaryToWriter
      );
    }
    f = message.getRearImageList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        7,
        f,
        proto.com.smartcloudsolutions.tollingvision.Image
          .serializeBinaryToWriter
      );
    }
    f = message.getOverviewImageList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        8,
        f,
        proto.com.smartcloudsolutions.tollingvision.Image
          .serializeBinaryToWriter
      );
    }
    f = message.getMaxSearch();
    if (f !== 0) {
      writer.writeUint32(9, f);
    }
    f = message.getMaxRotation();
    if (f !== 0) {
      writer.writeUint32(10, f);
    }
    f = message.getMaxCharacterSize();
    if (f !== 0) {
      writer.writeSint32(11, f);
    }
    f = message.getRegionList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        12,
        f,
        proto.com.smartcloudsolutions.tollingvision.Region
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional bool sign_recognition = 1;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getSignRecognition =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 1, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setSignRecognition =
  function (value) {
    return Message.setProto3BooleanField(this, 1, value);
  };

/**
 * optional bool international_recognition = 2;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getInternationalRecognition =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 2, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setInternationalRecognition =
  function (value) {
    return Message.setProto3BooleanField(this, 2, value);
  };

/**
 * optional bool resampling = 3;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getResampling =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 3, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setResampling =
  function (value) {
    return Message.setField(this, 3, value);
  };

/**
 * Clears the field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.clearResampling =
  function () {
    return Message.setField(this, 3, undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.hasResampling =
  function () {
    return Message.getField(this, 3) != null;
  };

/**
 * optional bool results_without_plate_type = 4;
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getResultsWithoutPlateType =
  function () {
    return /** @type {boolean} */ (
      Message.getBooleanFieldWithDefault(this, 4, false)
    );
  };

/**
 * @param {boolean} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setResultsWithoutPlateType =
  function (value) {
    return Message.setProto3BooleanField(this, 4, value);
  };

/**
 * optional string location = 5;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getLocation =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 5, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setLocation =
  function (value) {
    return Message.setProto3StringField(this, 5, value);
  };

/**
 * repeated Image front_image = 6;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Image>}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getFrontImageList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Image>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Image,
        6
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Image>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setFrontImageList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 6, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Image}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.addFrontImage =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      6,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Image,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.clearFrontImageList =
  function () {
    return this.setFrontImageList([]);
  };

/**
 * repeated Image rear_image = 7;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Image>}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getRearImageList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Image>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Image,
        7
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Image>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setRearImageList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 7, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Image}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.addRearImage =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      7,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Image,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.clearRearImageList =
  function () {
    return this.setRearImageList([]);
  };

/**
 * repeated Image overview_image = 8;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Image>}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getOverviewImageList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Image>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Image,
        8
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Image>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setOverviewImageList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 8, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Image}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.addOverviewImage =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      8,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Image,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.clearOverviewImageList =
  function () {
    return this.setOverviewImageList([]);
  };

/**
 * optional uint32 max_search = 9;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getMaxSearch =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 9, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setMaxSearch =
  function (value) {
    return Message.setProto3IntField(this, 9, value);
  };

/**
 * optional uint32 max_rotation = 10;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getMaxRotation =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 10, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setMaxRotation =
  function (value) {
    return Message.setProto3IntField(this, 10, value);
  };

/**
 * optional sint32 max_character_size = 11;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getMaxCharacterSize =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 11, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setMaxCharacterSize =
  function (value) {
    return Message.setProto3IntField(this, 11, value);
  };

/**
 * repeated Region region = 12;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Region>}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.getRegionList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Region>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Region,
        12
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Region>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.setRegionList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 12, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Region=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Region}
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.addRegion =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      12,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Region,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventRequest} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventRequest.prototype.clearRegionList =
  function () {
    return this.setRegionList([]);
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {};

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest}
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg =
      new proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest();
    return proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest}
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusRequest.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {};

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg =
      new proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest();
    return proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusRequest.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.ErrorResponse.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.ErrorResponse.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.ErrorResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.ErrorResponse.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          requestId: Message.getFieldWithDefault(msg, 1, ""),
          code: Message.getFieldWithDefault(msg, 2, 0),
          node: Message.getFieldWithDefault(msg, 3, ""),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.ErrorResponse}
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.ErrorResponse();
    return proto.com.smartcloudsolutions.tollingvision.ErrorResponse.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.ErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.ErrorResponse}
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setRequestId(value);
          break;
        case 2:
          var value =
            /** @type {!proto.com.smartcloudsolutions.tollingvision.Error} */ (
              reader.readEnum()
            );
          msg.setCode(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setNode(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.ErrorResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.ErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getRequestId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getCode();
    if (f !== 0.0) {
      writer.writeEnum(2, f);
    }
    f = message.getNode();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
  };

/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.prototype.getRequestId =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.ErrorResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.prototype.setRequestId =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * optional Error code = 2;
 * @return {!proto.com.smartcloudsolutions.tollingvision.Error}
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.prototype.getCode =
  function () {
    return /** @type {!proto.com.smartcloudsolutions.tollingvision.Error} */ (
      Message.getFieldWithDefault(this, 2, 0)
    );
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Error} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.ErrorResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.prototype.setCode =
  function (value) {
    return Message.setProto3EnumField(this, 2, value);
  };

/**
 * optional string node = 3;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.prototype.getNode =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 3, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.ErrorResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.ErrorResponse.prototype.setNode =
  function (value) {
    return Message.setProto3StringField(this, 3, value);
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.repeatedFields_ = [
  7,
];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.SearchResponse.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.SearchResponse.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          requestId: Message.getFieldWithDefault(msg, 1, ""),
          node: Message.getFieldWithDefault(msg, 2, ""),
          status: Message.getFieldWithDefault(msg, 3, 0),
          queueingTime: Message.getFieldWithDefault(msg, 4, 0),
          recognitionTime: Message.getFieldWithDefault(msg, 5, 0),
          inputImageOrientation: Message.getFieldWithDefault(msg, 6, 0),
          resultList: Message.toObjectList(
            msg.getResultList(),
            proto.com.smartcloudsolutions.tollingvision.Vehicle.toObject,
            includeInstance
          ),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.SearchResponse();
    return proto.com.smartcloudsolutions.tollingvision.SearchResponse.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setRequestId(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setNode(value);
          break;
        case 3:
          var value =
            /** @type {!proto.com.smartcloudsolutions.tollingvision.Status} */ (
              reader.readEnum()
            );
          msg.setStatus(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setQueueingTime(value);
          break;
        case 5:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setRecognitionTime(value);
          break;
        case 6:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setInputImageOrientation(value);
          break;
        case 7:
          var value = new proto.com.smartcloudsolutions.tollingvision.Vehicle();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Vehicle
              .deserializeBinaryFromReader
          );
          msg.addResult(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.SearchResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getRequestId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getNode();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message.getStatus();
    if (f !== 0.0) {
      writer.writeEnum(3, f);
    }
    f = message.getQueueingTime();
    if (f !== 0) {
      writer.writeUint64(4, f);
    }
    f = message.getRecognitionTime();
    if (f !== 0) {
      writer.writeUint64(5, f);
    }
    f = message.getInputImageOrientation();
    if (f !== 0) {
      writer.writeUint32(6, f);
    }
    f = message.getResultList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        7,
        f,
        proto.com.smartcloudsolutions.tollingvision.Vehicle
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.getRequestId =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.setRequestId =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * optional string node = 2;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.getNode =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 2, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.setNode =
  function (value) {
    return Message.setProto3StringField(this, 2, value);
  };

/**
 * optional Status status = 3;
 * @return {!proto.com.smartcloudsolutions.tollingvision.Status}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.getStatus =
  function () {
    return /** @type {!proto.com.smartcloudsolutions.tollingvision.Status} */ (
      Message.getFieldWithDefault(this, 3, 0)
    );
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Status} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.setStatus =
  function (value) {
    return Message.setProto3EnumField(this, 3, value);
  };

/**
 * optional uint64 queueing_time = 4;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.getQueueingTime =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 4, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.setQueueingTime =
  function (value) {
    return Message.setProto3IntField(this, 4, value);
  };

/**
 * optional uint64 recognition_time = 5;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.getRecognitionTime =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 5, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.setRecognitionTime =
  function (value) {
    return Message.setProto3IntField(this, 5, value);
  };

/**
 * optional uint32 input_image_orientation = 6;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.getInputImageOrientation =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 6, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.setInputImageOrientation =
  function (value) {
    return Message.setProto3IntField(this, 6, value);
  };

/**
 * repeated Vehicle result = 7;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Vehicle>}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.getResultList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Vehicle>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Vehicle,
        7
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Vehicle>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.setResultList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 7, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Vehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Vehicle}
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.addResult =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      7,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Vehicle,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.SearchResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.SearchResponse.prototype.clearResultList =
  function () {
    return this.setResultList([]);
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.repeatedFields_ = [
  3, 5, 7, 8,
];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.EventResult.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.EventResult} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.EventResult.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        node: Message.getFieldWithDefault(msg, 1, ""),
        frontPlate:
          (f = msg.getFrontPlate()) &&
          proto.com.smartcloudsolutions.tollingvision.Plate.toObject(
            includeInstance,
            f
          ),
        frontPlateAlternativeList: Message.toObjectList(
          msg.getFrontPlateAlternativeList(),
          proto.com.smartcloudsolutions.tollingvision.Plate.toObject,
          includeInstance
        ),
        rearPlate:
          (f = msg.getRearPlate()) &&
          proto.com.smartcloudsolutions.tollingvision.Plate.toObject(
            includeInstance,
            f
          ),
        rearPlateAlternativeList: Message.toObjectList(
          msg.getRearPlateAlternativeList(),
          proto.com.smartcloudsolutions.tollingvision.Plate.toObject,
          includeInstance
        ),
        mmr:
          (f = msg.getMmr()) &&
          proto.com.smartcloudsolutions.tollingvision.Mmr.toObject(
            includeInstance,
            f
          ),
        mmrAlternativeList: Message.toObjectList(
          msg.getMmrAlternativeList(),
          proto.com.smartcloudsolutions.tollingvision.Mmr.toObject,
          includeInstance
        ),
        signList: Message.toObjectList(
          msg.getSignList(),
          proto.com.smartcloudsolutions.tollingvision.Sign.toObject,
          includeInstance
        ),
        processingTime: Message.getFieldWithDefault(msg, 9, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.EventResult();
    return proto.com.smartcloudsolutions.tollingvision.EventResult.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.EventResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setNode(value);
          break;
        case 2:
          var value = new proto.com.smartcloudsolutions.tollingvision.Plate();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Plate
              .deserializeBinaryFromReader
          );
          msg.setFrontPlate(value);
          break;
        case 3:
          var value = new proto.com.smartcloudsolutions.tollingvision.Plate();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Plate
              .deserializeBinaryFromReader
          );
          msg.addFrontPlateAlternative(value);
          break;
        case 4:
          var value = new proto.com.smartcloudsolutions.tollingvision.Plate();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Plate
              .deserializeBinaryFromReader
          );
          msg.setRearPlate(value);
          break;
        case 5:
          var value = new proto.com.smartcloudsolutions.tollingvision.Plate();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Plate
              .deserializeBinaryFromReader
          );
          msg.addRearPlateAlternative(value);
          break;
        case 6:
          var value = new proto.com.smartcloudsolutions.tollingvision.Mmr();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Mmr
              .deserializeBinaryFromReader
          );
          msg.setMmr(value);
          break;
        case 7:
          var value = new proto.com.smartcloudsolutions.tollingvision.Mmr();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Mmr
              .deserializeBinaryFromReader
          );
          msg.addMmrAlternative(value);
          break;
        case 8:
          var value = new proto.com.smartcloudsolutions.tollingvision.Sign();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.Sign
              .deserializeBinaryFromReader
          );
          msg.addSign(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setProcessingTime(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.EventResult.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.EventResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getNode();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getFrontPlate();
    if (f != null) {
      writer.writeMessage(
        2,
        f,
        proto.com.smartcloudsolutions.tollingvision.Plate
          .serializeBinaryToWriter
      );
    }
    f = message.getFrontPlateAlternativeList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        3,
        f,
        proto.com.smartcloudsolutions.tollingvision.Plate
          .serializeBinaryToWriter
      );
    }
    f = message.getRearPlate();
    if (f != null) {
      writer.writeMessage(
        4,
        f,
        proto.com.smartcloudsolutions.tollingvision.Plate
          .serializeBinaryToWriter
      );
    }
    f = message.getRearPlateAlternativeList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        5,
        f,
        proto.com.smartcloudsolutions.tollingvision.Plate
          .serializeBinaryToWriter
      );
    }
    f = message.getMmr();
    if (f != null) {
      writer.writeMessage(
        6,
        f,
        proto.com.smartcloudsolutions.tollingvision.Mmr.serializeBinaryToWriter
      );
    }
    f = message.getMmrAlternativeList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        7,
        f,
        proto.com.smartcloudsolutions.tollingvision.Mmr.serializeBinaryToWriter
      );
    }
    f = message.getSignList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        8,
        f,
        proto.com.smartcloudsolutions.tollingvision.Sign.serializeBinaryToWriter
      );
    }
    f = message.getProcessingTime();
    if (f !== 0) {
      writer.writeUint64(9, f);
    }
  };

/**
 * optional string node = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.getNode =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.setNode =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * optional Plate front_plate = 2;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Plate}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.getFrontPlate =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Plate} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Plate,
        2
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Plate|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.setFrontPlate =
  function (value) {
    return Message.setWrapperField(this, 2, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.clearFrontPlate =
  function () {
    return this.setFrontPlate(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.hasFrontPlate =
  function () {
    return Message.getField(this, 2) != null;
  };

/**
 * repeated Plate front_plate_alternative = 3;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Plate>}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.getFrontPlateAlternativeList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Plate>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Plate,
        3
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Plate>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.setFrontPlateAlternativeList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 3, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Plate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.addFrontPlateAlternative =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      3,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Plate,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.clearFrontPlateAlternativeList =
  function () {
    return this.setFrontPlateAlternativeList([]);
  };

/**
 * optional Plate rear_plate = 4;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Plate}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.getRearPlate =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Plate} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Plate,
        4
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Plate|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.setRearPlate =
  function (value) {
    return Message.setWrapperField(this, 4, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.clearRearPlate =
  function () {
    return this.setRearPlate(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.hasRearPlate =
  function () {
    return Message.getField(this, 4) != null;
  };

/**
 * repeated Plate rear_plate_alternative = 5;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Plate>}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.getRearPlateAlternativeList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Plate>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Plate,
        5
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Plate>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.setRearPlateAlternativeList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 5, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Plate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Plate}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.addRearPlateAlternative =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      5,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Plate,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.clearRearPlateAlternativeList =
  function () {
    return this.setRearPlateAlternativeList([]);
  };

/**
 * optional Mmr mmr = 6;
 * @return {?proto.com.smartcloudsolutions.tollingvision.Mmr}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.getMmr =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.Mmr} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Mmr,
        6
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.Mmr|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.setMmr =
  function (value) {
    return Message.setWrapperField(this, 6, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.clearMmr =
  function () {
    return this.setMmr(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.hasMmr =
  function () {
    return Message.getField(this, 6) != null;
  };

/**
 * repeated Mmr mmr_alternative = 7;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Mmr>}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.getMmrAlternativeList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Mmr>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Mmr,
        7
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Mmr>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.setMmrAlternativeList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 7, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Mmr=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Mmr}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.addMmrAlternative =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      7,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Mmr,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.clearMmrAlternativeList =
  function () {
    return this.setMmrAlternativeList([]);
  };

/**
 * repeated Sign sign = 8;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.Sign>}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.getSignList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.Sign>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.Sign,
        8
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.Sign>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.setSignList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 8, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.Sign=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.Sign}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.addSign =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      8,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.Sign,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.clearSignList =
  function () {
    return this.setSignList([]);
  };

/**
 * optional uint64 processing_time = 9;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.getProcessingTime =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 9, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResult.prototype.setProcessingTime =
  function (value) {
    return Message.setProto3IntField(this, 9, value);
  };

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.oneofGroups_ = [
  [3, 4],
];

/**
 * @enum {number}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.ResponseCase = {
  RESPONSE_NOT_SET: 0,
  ERROR: 3,
  RESULT: 4,
};

/**
 * @return {proto.com.smartcloudsolutions.tollingvision.PartialResult.ResponseCase}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.getResponseCase =
  function () {
    return /** @type {proto.com.smartcloudsolutions.tollingvision.PartialResult.ResponseCase} */ (
      Message.computeOneofCase(
        this,
        proto.com.smartcloudsolutions.tollingvision.PartialResult
          .oneofGroups_[0]
      )
    );
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.PartialResult.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.PartialResult} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.PartialResult.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          resultType: Message.getFieldWithDefault(msg, 1, 0),
          resultIndex: Message.getFieldWithDefault(msg, 2, 0),
          error:
            (f = msg.getError()) &&
            proto.com.smartcloudsolutions.tollingvision.ErrorResponse.toObject(
              includeInstance,
              f
            ),
          result:
            (f = msg.getResult()) &&
            proto.com.smartcloudsolutions.tollingvision.SearchResponse.toObject(
              includeInstance,
              f
            ),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.PartialResult}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.PartialResult();
    return proto.com.smartcloudsolutions.tollingvision.PartialResult.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.PartialResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.PartialResult}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value =
            /** @type {!proto.com.smartcloudsolutions.tollingvision.ResultType} */ (
              reader.readEnum()
            );
          msg.setResultType(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setResultIndex(value);
          break;
        case 3:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.ErrorResponse();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.ErrorResponse
              .deserializeBinaryFromReader
          );
          msg.setError(value);
          break;
        case 4:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.SearchResponse();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.SearchResponse
              .deserializeBinaryFromReader
          );
          msg.setResult(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.PartialResult.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.PartialResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getResultType();
    if (f !== 0.0) {
      writer.writeEnum(1, f);
    }
    f = message.getResultIndex();
    if (f !== 0) {
      writer.writeUint32(2, f);
    }
    f = message.getError();
    if (f != null) {
      writer.writeMessage(
        3,
        f,
        proto.com.smartcloudsolutions.tollingvision.ErrorResponse
          .serializeBinaryToWriter
      );
    }
    f = message.getResult();
    if (f != null) {
      writer.writeMessage(
        4,
        f,
        proto.com.smartcloudsolutions.tollingvision.SearchResponse
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional ResultType result_type = 1;
 * @return {!proto.com.smartcloudsolutions.tollingvision.ResultType}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.getResultType =
  function () {
    return /** @type {!proto.com.smartcloudsolutions.tollingvision.ResultType} */ (
      Message.getFieldWithDefault(this, 1, 0)
    );
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.ResultType} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.PartialResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.setResultType =
  function (value) {
    return Message.setProto3EnumField(this, 1, value);
  };

/**
 * optional uint32 result_index = 2;
 * @return {number}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.getResultIndex =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 2, 0));
  };

/**
 * @param {number} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.PartialResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.setResultIndex =
  function (value) {
    return Message.setProto3IntField(this, 2, value);
  };

/**
 * optional ErrorResponse error = 3;
 * @return {?proto.com.smartcloudsolutions.tollingvision.ErrorResponse}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.getError =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.ErrorResponse} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.ErrorResponse,
        3
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.ErrorResponse|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.PartialResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.setError =
  function (value) {
    return Message.setOneofWrapperField(
      this,
      3,
      proto.com.smartcloudsolutions.tollingvision.PartialResult.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.PartialResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.clearError =
  function () {
    return this.setError(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.hasError =
  function () {
    return Message.getField(this, 3) != null;
  };

/**
 * optional SearchResponse result = 4;
 * @return {?proto.com.smartcloudsolutions.tollingvision.SearchResponse}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.getResult =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.SearchResponse} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.SearchResponse,
        4
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.SearchResponse|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.PartialResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.setResult =
  function (value) {
    return Message.setOneofWrapperField(
      this,
      4,
      proto.com.smartcloudsolutions.tollingvision.PartialResult.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.PartialResult} returns this
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.clearResult =
  function () {
    return this.setResult(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.PartialResult.prototype.hasResult =
  function () {
    return Message.getField(this, 4) != null;
  };

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.oneofGroups_ = [
  [3, 4],
];

/**
 * @enum {number}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.ResponseCase = {
  RESPONSE_NOT_SET: 0,
  PARTIAL_RESULT: 3,
  EVENT_RESULT: 4,
};

/**
 * @return {proto.com.smartcloudsolutions.tollingvision.EventResponse.ResponseCase}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.getResponseCase =
  function () {
    return /** @type {proto.com.smartcloudsolutions.tollingvision.EventResponse.ResponseCase} */ (
      Message.computeOneofCase(
        this,
        proto.com.smartcloudsolutions.tollingvision.EventResponse
          .oneofGroups_[0]
      )
    );
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.EventResponse.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.EventResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.EventResponse.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          eventId: Message.getFieldWithDefault(msg, 1, ""),
          node: Message.getFieldWithDefault(msg, 2, ""),
          partialResult:
            (f = msg.getPartialResult()) &&
            proto.com.smartcloudsolutions.tollingvision.PartialResult.toObject(
              includeInstance,
              f
            ),
          eventResult:
            (f = msg.getEventResult()) &&
            proto.com.smartcloudsolutions.tollingvision.EventResult.toObject(
              includeInstance,
              f
            ),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResponse}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg = new proto.com.smartcloudsolutions.tollingvision.EventResponse();
    return proto.com.smartcloudsolutions.tollingvision.EventResponse.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.EventResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResponse}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setEventId(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setNode(value);
          break;
        case 3:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.PartialResult();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.PartialResult
              .deserializeBinaryFromReader
          );
          msg.setPartialResult(value);
          break;
        case 4:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.EventResult();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.EventResult
              .deserializeBinaryFromReader
          );
          msg.setEventResult(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.EventResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.EventResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getEventId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getNode();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message.getPartialResult();
    if (f != null) {
      writer.writeMessage(
        3,
        f,
        proto.com.smartcloudsolutions.tollingvision.PartialResult
          .serializeBinaryToWriter
      );
    }
    f = message.getEventResult();
    if (f != null) {
      writer.writeMessage(
        4,
        f,
        proto.com.smartcloudsolutions.tollingvision.EventResult
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.getEventId =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.setEventId =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * optional string node = 2;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.getNode =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 2, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.setNode =
  function (value) {
    return Message.setProto3StringField(this, 2, value);
  };

/**
 * optional PartialResult partial_result = 3;
 * @return {?proto.com.smartcloudsolutions.tollingvision.PartialResult}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.getPartialResult =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.PartialResult} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.PartialResult,
        3
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.PartialResult|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.setPartialResult =
  function (value) {
    return Message.setOneofWrapperField(
      this,
      3,
      proto.com.smartcloudsolutions.tollingvision.EventResponse.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.clearPartialResult =
  function () {
    return this.setPartialResult(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.hasPartialResult =
  function () {
    return Message.getField(this, 3) != null;
  };

/**
 * optional EventResult event_result = 4;
 * @return {?proto.com.smartcloudsolutions.tollingvision.EventResult}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.getEventResult =
  function () {
    return /** @type{?proto.com.smartcloudsolutions.tollingvision.EventResult} */ (
      Message.getWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.EventResult,
        4
      )
    );
  };

/**
 * @param {?proto.com.smartcloudsolutions.tollingvision.EventResult|undefined} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.setEventResult =
  function (value) {
    return Message.setOneofWrapperField(
      this,
      4,
      proto.com.smartcloudsolutions.tollingvision.EventResponse.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.smartcloudsolutions.tollingvision.EventResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.clearEventResult =
  function () {
    return this.setEventResult(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.smartcloudsolutions.tollingvision.EventResponse.prototype.hasEventResult =
  function () {
    return Message.getField(this, 4) != null;
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.repeatedFields_ =
  [2];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          node: Message.getFieldWithDefault(msg, 1, ""),
          entryList: Message.toObjectList(
            msg.getEntryList(),
            proto.com.smartcloudsolutions.tollingvision.KeyValuePair.toObject,
            includeInstance
          ),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse}
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg =
      new proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse();
    return proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse}
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setNode(value);
          break;
        case 2:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.KeyValuePair();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.KeyValuePair
              .deserializeBinaryFromReader
          );
          msg.addEntry(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getNode();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getEntryList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        2,
        f,
        proto.com.smartcloudsolutions.tollingvision.KeyValuePair
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional string node = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.prototype.getNode =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.prototype.setNode =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * repeated KeyValuePair entry = 2;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.KeyValuePair>}
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.prototype.getEntryList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.KeyValuePair>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.KeyValuePair,
        2
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.KeyValuePair>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.prototype.setEntryList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 2, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.KeyValuePair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.KeyValuePair}
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.prototype.addEntry =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      2,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.KeyValuePair,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.ServerStatusResponse.prototype.clearEntryList =
  function () {
    return this.setEntryList([]);
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.repeatedFields_ =
  [2];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.prototype.toObject =
    function (opt_includeInstance) {
      return proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.toObject =
    function (includeInstance, msg) {
      var f,
        obj = {
          node: Message.getFieldWithDefault(msg, 1, ""),
          statusList: Message.toObjectList(
            msg.getStatusList(),
            proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus
              .toObject,
            includeInstance
          ),
        };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.deserializeBinary =
  function (bytes) {
    var reader = new BinaryReader(bytes);
    var msg =
      new proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse();
    return proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.deserializeBinaryFromReader(
      msg,
      reader
    );
  };

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setNode(value);
          break;
        case 2:
          var value =
            new proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus();
          reader.readMessage(
            value,
            proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus
              .deserializeBinaryFromReader
          );
          msg.addStatus(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getNode();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getStatusList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        2,
        f,
        proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus
          .serializeBinaryToWriter
      );
    }
  };

/**
 * optional string node = 1;
 * @return {string}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.prototype.getNode =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.prototype.setNode =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * repeated LicenseServiceStatus status = 2;
 * @return {!Array<!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus>}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.prototype.getStatusList =
  function () {
    return /** @type{!Array<!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus,
        2
      )
    );
  };

/**
 * @param {!Array<!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus>} value
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.prototype.setStatusList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 2, value);
  };

/**
 * @param {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus}
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.prototype.addStatus =
  function (opt_value, opt_index) {
    return Message.addToRepeatedWrapperField(
      this,
      2,
      opt_value,
      proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatus,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse} returns this
 */
proto.com.smartcloudsolutions.tollingvision.LicenseServiceStatusResponse.prototype.clearStatusList =
  function () {
    return this.setStatusList([]);
  };

/**
 * @enum {number}
 */
proto.com.smartcloudsolutions.tollingvision.Status = {
  QUEUEING: 0,
  PROCESSING: 1,
  RESULT: 2,
};

/**
 * @enum {number}
 */
proto.com.smartcloudsolutions.tollingvision.ResultType = {
  FRONT: 0,
  REAR: 1,
  OVERVIEW: 2,
};

/**
 * @enum {number}
 */
proto.com.smartcloudsolutions.tollingvision.Error = {
  EMPTY_IMAGE: 0,
  INVALID_IMAGE_FORMAT: 1,
  INVALID_MAX_SEARCH: 2,
  INVALID_MAX_ROTATION: 3,
  INVALID_MAX_CHARACTER_SIZE: 4,
  TOO_MANY_REQUESTS: 5,
  TIMEOUT_OCCURRED: 6,
  INTERNAL_ERROR: 7,
  FORBIDDEN: 8,
  LIMIT_EXCEEDED: 9,
};

/**
 * @enum {number}
 */
proto.com.smartcloudsolutions.tollingvision.SignType = {
  GENERAL: 0,
  IMO: 1,
  A: 2,
  EMPTY: 3,
};

goog.object.extend(exports, proto.com.smartcloudsolutions.tollingvision);
